export const UserRole = {
  SuperAdmin: 'SuperAdmin',
  Admin: 'Admin',
  Doctor: 'Doctor',
  AsstDoctor: 'AsstDoctor',
  Receptionist: 'Receptionist',
  Pharmacist: 'Pharmacist',
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];
export type RoleGroup = readonly UserRole[];

export const ROLE_GROUPS = {
  PlatformAdmin: [UserRole.SuperAdmin],
  AllAuthenticated: [
    UserRole.SuperAdmin,
    UserRole.Admin,
    UserRole.Doctor,
    UserRole.AsstDoctor,
    UserRole.Receptionist,
    UserRole.Pharmacist,
  ],
  AdminOnly: [UserRole.Admin],
  ClinicalSenior: [UserRole.Admin, UserRole.Doctor],
  Consultation: [UserRole.Doctor, UserRole.AsstDoctor],
  Clinical: [UserRole.Admin, UserRole.Doctor, UserRole.AsstDoctor],
  AllTenant: [
    UserRole.Admin,
    UserRole.Doctor,
    UserRole.AsstDoctor,
    UserRole.Receptionist,
  ],
  Pharmacy: [UserRole.Admin, UserRole.Pharmacist],
  ClinicalAndPharmacy: [
    UserRole.Admin,
    UserRole.Doctor,
    UserRole.AsstDoctor,
    UserRole.Pharmacist,
  ],
  TenantAndPharmacy: [
    UserRole.Admin,
    UserRole.Doctor,
    UserRole.AsstDoctor,
    UserRole.Receptionist,
    UserRole.Pharmacist,
  ],
} as const satisfies Record<string, RoleGroup>;
